import HundredBricksAPIError from '../../../HundredBricksAPIError';
class ReleasePreviewError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('ReleasePreviewError', ...args);
    }
}
export default ReleasePreviewError;
